import React from 'react';
import PropTypes from 'prop-types';

const StatusUpdated = ({ updatedAt }) => (
  <div className="onboarding-status -success">
    <div className="onboarding-status_description">update saved {updatedAt}</div>
  </div>
);

StatusUpdated.propTypes = {
  updatedAt: PropTypes.string.isRequired,
};

export default React.memo(StatusUpdated);



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Status/StatusUpdated.js